import React from "react";
import { injuryBadge } from "./statEngineRows";

export function makePlayerCell(logoByAbbrev) {
  function PlayerCell({ row }) {
    const player = row.original;
    const badge = injuryBadge(player.injuryStatus);
    const logo = logoByAbbrev[player.team];

    return (
      <span className="nfl-player">
        {logo ? (
          <img className="nfl-player-logo" src={logo} alt="" width="22" height="22" />
        ) : (
          <span className="nfl-player-logo" aria-hidden="true" />
        )}
        <span className="nfl-player-text">
          <span className="nfl-player-name">
            {player.name}
            {badge ? (
              <abbr className="nfl-injury" title={badge.label}>
                {badge.short}
              </abbr>
            ) : null}
          </span>
          <span className="nfl-player-meta">
            {player.team} · {player.pos}
          </span>
        </span>
      </span>
    );
  }
  return PlayerCell;
}
